var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCustom48X48 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.001,
    viewBox: "0 0 24 24.001",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_custom_editor",
    d: "M995.833,539.14v10.113a.674.674,0,0,0,.672.674h18.823a.674.674,0,0,0,.672-.674h0V539.14a.673.673,0,0,0-.672-.674H996.5A.674.674,0,0,0,995.833,539.14Zm7.35,7.416h0a.67.67,0,0,1-.939-.133l0,0-1.614-2.157a.676.676,0,0,1,0-.809l1.614-2.157a.671.671,0,0,1,.938-.138l0,0h0a.674.674,0,0,1,.134.944l-1.008,1.349a.676.676,0,0,0,0,.809l1.008,1.349A.674.674,0,0,1,1003.183,546.556Zm2.689.674h0a.674.674,0,0,1-.672-.674h0v-5.394a.673.673,0,0,1,.672-.674h0a.672.672,0,0,1,.672.674h0v5.394a.672.672,0,0,1-.671.674h0Zm2.689-.674h0a.676.676,0,0,1-.135-.944l1.008-1.349a.674.674,0,0,0,0-.809l-1.008-1.349a.676.676,0,0,1,.135-.944h0a.671.671,0,0,1,.939.131l0,0,1.614,2.157a.674.674,0,0,1,0,.809l-1.614,2.157a.669.669,0,0,1-.938.139l0,0Zm-1.679-17.286v4.4h3.768ZM994.7,536.6h15.754a.708.708,0,0,0,.709-.706h0a.707.707,0,0,0-.709-.706h-4.969v-6.353H992.709a.707.707,0,0,0-.709.705v22.59a.707.707,0,0,0,.709.706h17.744a.708.708,0,0,0,.709-.706h0a.707.707,0,0,0-.709-.706H994.7a.709.709,0,0,1-.71-.706V537.308a.708.708,0,0,1,.706-.71Z",
    transform: "translate(-992 -528.833)",
    fill: "#00a1af"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCustom48X48);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_custom48x48.38a7e126462443a9a705889e112a74c2.svg";